import { render, staticRenderFns } from "./userData.vue?vue&type=template&id=036f7e54"
import script from "./userData.vue?vue&type=script&lang=js"
export * from "./userData.vue?vue&type=script&lang=js"
import style0 from "./userData.vue?vue&type=style&index=0&id=036f7e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports